import React from 'react';
import { XCircle, AlertTriangle } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { Card } from './ui/Card';
export function WhyItFailsSection() {
  const failures = [{
    title: 'Contacto Cero Pasivo',
    desc: 'Solo funciona si ya tienes un valor extremadamente alto; de lo contrario, solo facilita que te olviden.'
  }, {
    title: 'Rogar y Explicaciones',
    desc: 'Huele a necesidad, y la necesidad repele el deseo de forma biológica. Te vuelve predecible.'
  }, {
    title: 'Consejos de Amigos',
    desc: "Te dicen 'ya llegará alguien mejor', pero eso no soluciona tu problema de ansiedad hoy mismo."
  }, {
    title: 'Seguir sus Historias',
    desc: 'Te mantiene en un ciclo de dopamina negativa que destruye tu confianza lentamente.'
  }];
  return <section className="py-20 relative" data-id="element-296">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-297">
        <FadeIn data-id="element-298">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-299">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-300">
              El error del <span className="text-[#ff3366]" data-id="element-301">95%</span> de las
              personas
            </h2>
            <p className="text-xl text-gray-400" data-id="element-302">
              Actuar bajo "Pánico de Supervivencia" reafirma su decisión de
              haberte dejado. Lo que has intentado hasta ahora está programado
              para fallar.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-303">
          {failures.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-304">
              <Card hoverEffect glowColor="red" className="h-full border-l-4 border-l-[#ff3366] bg-gradient-to-r from-[#ff3366]/5 to-transparent" data-id="element-305">
                <div className="flex items-start gap-4" data-id="element-306">
                  <XCircle className="w-6 h-6 text-[#ff3366] flex-shrink-0 mt-1" data-id="element-307" />
                  <div data-id="element-308">
                    <h3 className="text-xl font-bold text-white mb-2" data-id="element-309">
                      {item.title}
                    </h3>
                    <p className="text-gray-400" data-id="element-310">{item.desc}</p>
                  </div>
                </div>
              </Card>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-311">
          <div className="mt-12 flex items-center justify-center gap-3 text-[#ff3366] bg-[#ff3366]/10 py-4 px-6 rounded-lg max-w-2xl mx-auto border border-[#ff3366]/20" data-id="element-312">
            <AlertTriangle className="w-6 h-6" data-id="element-313" />
            <p className="font-semibold" data-id="element-314">
              Estás disponible 24/7 y eso, psicológicamente, es lo opuesto a lo
              atractivo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}